import { Drawer } from "antd"
import VoucherCard from "./VoucherCard"
import VoucherList from "./VoucherList";

export default function CouponDrawer({ open, onClose }: { open: boolean; onClose: () => void }) {
    return (
        <Drawer
            open={open}
            onClose={onClose}
            placement="right"
            width="30%"
            style={{ minWidth: 436, zIndex: 1400 }}
            closeIcon={false}
            bodyStyle={{ padding: 0 }}
            headerStyle={{ display: "none" }}
            rootClassName="ovh-hidden"
        >
            {/* HEADER */}
            <div className="MuiBox-root css-xjv6ud">
                <div className="MuiBox-root css-1qnpokk">
                    <span className="styles_drawerHeadTitle__TZ1RV">
                        Mã giảm giá có thể sử dụng
                    </span>

                    <button
                        className="MuiButtonBase-root MuiIconButton-root"
                        type="button"
                        style={{ padding: 5 }}
                        onClick={onClose}
                    >
                        <svg
                            viewBox="0 0 24 24"
                            style={{
                                width: 20,
                                height: 20,
                                strokeWidth: 1,
                                stroke: "rgb(121,121,121)",
                            }}
                        >
                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </svg>
                    </button>
                </div>

                <hr className="MuiDivider-root" />
            </div>

            {/* BODY */}
            <div className="styles_couponListWrapper__6AD6m">
                {/* SELLER SECTION */}
                <div className="styles_sectionVoucher_sticky__DlbAS">
                    <p className="MuiTypography-root styles_sectionVoucher_title__7Cux6">
                        Mã giảm giá từ nhà bán hàng
                    </p>
                </div>

                {/* 1 voucher card (ví dụ) */}
                <VoucherList />

                <div className="styles_newDivider__vn2GG" />

                {/* MARKETPLACE SECTION */}
                <div className="styles_sectionVoucher_sticky__DlbAS">
                    <p className="MuiTypography-root styles_sectionVoucher_title__7Cux6">
                        Mã giảm giá từ Buymed
                    </p>
                </div>

                <VoucherList />
                <div><button className="MuiButtonBase-root MuiButton-root MuiButton-text styles_btnSeeMoreItem__8fQxp" tabIndex={0} type="button"><span className="MuiButton-label">Xem thêm <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={{ width: "24px", height: "24px" }}><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg></span><span className="MuiTouchRipple-root"></span></button></div>
            </div>
        </Drawer>
    )
}
